import { useState } from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next"; 

const GreatJob = ({ toggleModal, handleVerify, isLoading, isSignSimpli }) => {
  const { t } = useTranslation();
   
  return (
    <>
      <div className="border-b border-gray-200 relative">
        {/* Close Button */}
        {!isSignSimpli && (
          <div className={`absolute top-0 right-0 ${isSignSimpli ? "pt-2 pr-2" : "pt-4 pr-4"} z-20`}>
            <button
              type="button"
              className="rounded-md text-gray-400 hover:text-gray-600 focus:outline-none focus:ring-0"
              onClick={() => toggleModal(false)}
            >
              <span className="sr-only">Close</span>
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
        )}
      </div>

      <div className={`${isSignSimpli ? "p-[30px] font-rethink" : "p-6"} relative bg-white rounded-[6px]`}>
        {/* Circle Icon */}
        <div className="flex justify-center mb-4">
          <div className="flex items-center justify-center w-16 h-16 rounded-full">
            {isSignSimpli ? (
              <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="60" height="60" rx="30" fill="#1D7FFF" />
                <path
                  d="M26.2793 31.4171L32.6579 37.7957L48.2502 22.2035"
                  stroke="#EAEBED"
                  strokeWidth="4.96"
                />
                <path d="M11.75 28.9372L20.2549 37.7965L35.8471 22.2042" stroke="white" strokeWidth="4.96" />
              </svg>
            ) : (
              <img
                className="check-icon"
                src={process.env.PUBLIC_URL + "/static/images/double-check-circle-green.svg"}
                width="180"
                alt="check icon"
              />
            )}
          </div>
        </div>

        {/* Title */}
        <h2 className="text-center text-[36px] font-semibold text-[#16283D]">{t("secure_simpli_content.great_job")}</h2>

        {/* Subtitle */}
        <p className={`${isSignSimpli ? "mt-4 text-[#264A73]" : "mt-2 text-[#687585]"} text-center text-sm `}>
          {isSignSimpli ? (
            <>
              To send your document out, <br />
              we first need to verify and secure your account
            </>
          ) : (
            <>
              {t("secure_simpli_content.account_created1")} <br />
              {t("secure_simpli_content.account_created2")}
            </>
          )}
        </p>

        {/* Button */}
        <div className="mt-6 flex justify-center">
          <button
            id="verify-email"
            type="button"
            onClick={() => handleVerify("email")}
            disabled={isLoading}
            className={`px-20 py-4 text-white leading-[120%] !font-rethink tracking-[2%] text-md ${isSignSimpli ? "md:text-[18px] mb-4" : "md:text-xl"} font-bold rounded-[100px] bg-ps-reskin-radial hover:bg-hover-ps-reskin-radial uppercase transition-colors duration-1000 ease-in-out disabled:opacity-50 disabled:cursor-not-allowed`}
          >
            <span className="hidden md:block">{t("secure_simpli_content.verify_your_email")}</span>
            <span className="md:hidden">{t("secure_simpli_content.next")}</span>
          </button>
        </div>
      </div>
    </>
  );
};

export default GreatJob;
